import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import { deactivateUsers } from "../../api/endpoint";
import Loader from "../../components/loader";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const RemoveUserModal = ({
  isRemoveOpen,
  closeRemoveModal,
  selectedUserId,
  fetchUsers
}) => {
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const deactivateUser = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        deactivateUsers,
        {
          authIds: [selectedUserId],
        },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
      closeRemoveModal()
      fetchUsers()
      toast.success("User successfully deactivated");
    } catch (error) {
      console.error("Error deactivating user", error);
      toast.error("Error deactivating user");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader />}
      <Modal show={isRemoveOpen} onHide={closeRemoveModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Deactivate User</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this user?</Modal.Body>
        <Modal.Footer>
          <Button text="Deactivate User" callBack={deactivateUser} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RemoveUserModal;
